import { render, staticRenderFns } from "./BrandView.vue?vue&type=template&id=19099dd7&scoped=true"
import script from "./BrandView.vue?vue&type=script&lang=js"
export * from "./BrandView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19099dd7",
  null
  
)

export default component.exports